/* @flow */

import { combineReducers } from 'redux';

import entitiesReducer from './entitiesReducer';
import publicReducer from 'src/shared/domain/event/reducer/publicReducer';

// $FlowIssue
const domainReducer = combineReducers({
  entities: entitiesReducer,
  public: publicReducer,
});

export default domainReducer;
